export default __webpack_public_path__ + "static/media/logo.408fb8a8.jpg";